import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import styled from 'styled-components'
import BackgroundImage from 'gatsby-background-image'

const BackgroundSection = ({ children, className }) => (
    <StaticQuery query={graphql`
        query {
            homeBgDesktop: file(relativePath: { eq: "backgrounds/home-bg-desktop.png" }) {
                childImageSharp {
                    fluid(quality: 100, maxWidth: 1600) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            }
        }
    `}
        render={data => {
            // Set ImageData.
            const imageData = data.homeBgDesktop.childImageSharp.fluid
            return (
                <BackgroundImage Tag="section"
                    className={className}
                    fluid={imageData}
                    backgroundColor={`#000`}
                >
                    {children}
                </BackgroundImage>
            )
        }}
    />
)

const HomeBgImage = styled(BackgroundSection)`
    width: 100%;
    max-width: ${props => props.theme.sizes.xxl};
    margin: 0 auto;
    background-position: bottom center;
    background-repeat: no-repeat;
    background-size: 100%;
`

export default HomeBgImage